export default "__VITE_ASSET__b785bada__"